package com.essntl.core.quickbooks.di

import org.koin.core.annotation.ComponentScan
import org.koin.core.annotation.Module

@Module
@ComponentScan("com.essntl.core.quickbooks")
class QuickbooksClientImplModule()